export {
  ACCOUNT_REFERRALS_URI,
  ACTIVITIES_URI,
  BLOG_URL,
  ABOUT_US_URL,
  COMMUNITY_GUIDELINES_URL,
  HANK_HOST_PROGRAM_URL,
  HELP_CENTER_URL,
  HOME_URI,
  LOGIN_URI,
  LOGIN_AUTH0_URI,
  LOGIN_ERROR_URI,
  LOGIN_SUCCESS_URI,
  LOGOUT_AUTH0_URI,
  LOGOUT_URI,
  ME_URI,
  MEMBERS_URI,
  NOTIFICATIONS_URI,
  PRICING_URI,
  PRIVACY_POLICY_URI,
  PROFILE_URI,
  SIGN_UP_URI,
  SUBSCRIPTION_URI,
  TERMS_OF_SERVICE_URI,
  USER_HOME_URI,
  SIGN_UP_AUTH0_URI,
} from "@bullseye/routes"
